import React, { ReactNode } from 'react';
import { Box, Flex, Image } from '../Rebass';

import Icon from '../Icon';
import theme from '../../theme';
import styled from '@emotion/styled';

interface ListItemProps {
  icon?: string;
  image?: string;
  isLink?: boolean;
  hasBorder?: boolean;
  iconRight?: string;
  iconRightSize?: number;
  iconLeft?: string;
  iconLeftSize?: number;
  isSpaced?: boolean;
  py?: Array<number> | number;
  pr?: Array<number> | number;
  pt?: Array<number> | number;
  pb?: Array<number> | number;
  onMouseEnter?: (event: any) => void;
  children?: ReactNode;
  iconLeftColor?: string;
  iconRightColor?: string;
  renderIconLeft?: () => ReactNode;
  renderIconRight?: () => ReactNode;
}

const ListItemContainer = styled(Flex)(
  ({ isLink, hasBorder }: { isLink: boolean; hasBorder: boolean }) => `
    cursor: ${isLink ? 'pointer' : 'default'};
    border: 0;
    border-bottom: ${hasBorder ? '1px' : '0'};
    border-style: solid;
    border-color: ${theme.colors.borderDark};

    ${
      isLink
        ? `&:hover .list-item-headline {
      border-color: ${theme.colors.textDark};
    }`
        : ''
    }
  `,
);

const HeadlineContainer = styled(Box)`
  transition: border-color ${theme.speed.slow} ease;
  border-bottom: 1px solid ${theme.colors.transparent};
`;

const ListItem = ({
  icon,
  image,
  isLink,
  hasBorder,
  iconRight,
  iconLeft,
  iconRightSize = 16,
  iconLeftSize = 32,
  isSpaced,
  children,
  iconLeftColor,
  iconRightColor,
  renderIconLeft,
  renderIconRight,
  ...props
}: ListItemProps) => {
  return (
    <ListItemContainer
      justifyContent={isSpaced ? ['space-between'] : ['flex-start']}
      alignItems="center"
      isLink={isLink}
      hasBorder={hasBorder}
      {...props}
    >
      {image && <Image src={image} />}

      {iconLeft && (
        <Box css={{ lineHeight: 1 }} mr={[1]}>
          <Icon name={iconLeft} size={iconLeftSize} duoColor={iconLeftColor} />
        </Box>
      )}
      {renderIconLeft && (
        <Box css={{ lineHeight: 1 }} mr={[1]} flex="1 0 auto">
          {renderIconLeft()}
        </Box>
      )}
      <HeadlineContainer className="list-item-headline">
        {children}
      </HeadlineContainer>
      {iconRight && (
        <Box css={{ lineHeight: 1 }} ml={[1]}>
          <Icon
            name={iconRight}
            size={iconRightSize}
            sx={{ color: iconRightColor || 'textBlack' }}
          />
        </Box>
      )}
      {renderIconRight && (
        <Box css={{ lineHeight: 1 }} mr={[1]}>
          {renderIconRight()}
        </Box>
      )}
    </ListItemContainer>
  );
};

ListItem.defaultProps = {
  icon: null,
  image: null,
  isLink: false,
  hasBorder: false,
  isIconRight: false,
  isSpaced: false,
};

export default ListItem;
